import { FormikField } from 'components/common/form/field/FormikField';
import { CollapsibleSection } from 'components/CollapsibleSection';
import { ChannelGroupSetting } from 'core/channelGroup/ChannelGroupSettings';
import { connect } from 'formik';
import i18next from 'i18n';
import { FC } from 'react';
import styles from './agencyForm.module.scss';
import {
  getChannelGroupName,
  getVisibleCreativeTypes
} from './agencyAddonVisibility';
import { AddonSectionPlaceholder } from './AddonSectionPlaceholder';

const AgencyCreativeAddonForm: FC<any> = (props) => {
  const { addonFeatures } = props.formik.values;

  const renderChannelGroupCreativeSections = () => {
    return ChannelGroupSetting.activeValues()
      .map((channelGroup) => {
        // channel 關 或 父 ad type 全關時，該 group 的 creative type 不顯示
        const uniqueBannerTypes = getVisibleCreativeTypes(
          addonFeatures,
          channelGroup
        );
        if (uniqueBannerTypes.length === 0) {
          return null;
        }
        return (
          <CollapsibleSection
            key={channelGroup.config.id}
            title={getChannelGroupName(channelGroup)}
            collapsible={true}
          >
            <div className={styles.fieldContent}>
              {uniqueBannerTypes.map((bannerType) => (
                <FormikField.Switch
                  key={bannerType.bannerTypeId}
                  label={bannerType.name}
                  name={`addonFeatures.creatives.option_${bannerType.bannerTypeId}`}
                />
              ))}
            </div>
          </CollapsibleSection>
        );
      })
      .filter(Boolean);
  };

  const sections = renderChannelGroupCreativeSections();

  if (sections.length === 0) {
    return (
      <div className={styles.agencyFrom}>
        <AddonSectionPlaceholder
          message={i18next.t('agency.placeholders.addon', {
            parent: i18next.t('agencyDetail.labels.adTypeTab'),
            child: i18next.t('agency.addonGroup.creatives')
          })}
        />
      </div>
    );
  }

  return (
    <div className={styles.agencyFrom}>
      <fieldset>
        <legend>
          <span>{i18next.t('agency.addonGroup.creatives')}</span>
        </legend>
        <div className={styles.sectionsShadow}>{sections}</div>
      </fieldset>
    </div>
  );
};

export default connect(AgencyCreativeAddonForm);
